// import TestimonialAvatar from '../../images/testimonialAvatar.webp'
import React from 'react'
import LeftArrow from '../../images/leftArrow.webp'
import RightArrow from '../../images/rightArrow.webp'
import enviameCEO from '../../images/enviameCEO-96b80e2b.webp'
import enviameLogo from '../../images/aliado2.webp'
import goexCEO from '../../images/Perfil-goex-7b63975e.webp'
import goexLogo from '../../images/logo-goex.webp'
import cosmeticCLCEO from '../../images/cosmeticCLCEO-ab49e744.webp'
import cosmeticCLLogo from '../../images/cosmeticCLLogo.webp'
import italmodCEO from '../../images/italmodCEO-9803ac58.webp'
import italmodLogo from '../../images/italmod-sin-fondo.webp'
import shipitCEO from '../../images/shipitCEO-1f2b7353.webp'
import shipitLogo from '../../images/aliado3.webp'
import progamingIco from '../../images/progaming-ico.png'
import progamingLogo from '../../images/progaming-logo.png'
import dust2Ico from '../../images/dust2-ico.png'
import dust2Logo from '../../images/dust2-logo.png'
import ginoLogo from '../../images/gino-logo.png'
import westorageIco from '../../images/westorage-ceo.jpg'
import westorageLogo from '../../images/westorage-logo.png'
import productosdelujoCeo from '../../images/productosdelujo-ceo.jpeg'
import productosdelujoLogo from '../../images/productosdelujo-logo.png'
import nordvickLogo from '../../images/nordvik-logo.jpg'
import { Link } from 'gatsby'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function Testimonials() {

    const settings = {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        prevArrow: <div className="Content__testimonials--leftArrow"><img src={LeftArrow} alt="left-arrow" width="26" height="46" /></div>,
        nextArrow: <div className="Content__testimonials--rightArrow"><img src={RightArrow} alt="right-arrow" width="26" height="46" /></div>,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
              }
            },
        ]
    };

  return (
    <div className="Content__testimonials">
        <div className="container">
            <div className="Content__testimonials--title">
                <h2>¿Qué dicen de <span>nosotros?</span></h2>
            </div>
            <Slider {...settings} className="Content__testimonials--container">
                <div className="Content__testimonials--testimonial">
                    <div className="Content__testimonials--testimonial-icon">
                        <img src={enviameCEO} alt="enviame-ceo" style={{
                                width: "127%",
                                height: "auto",
                                objectFit: "cover",
                                position: "absolute",
                                top: "63%",
                                left: "54%",
                                transform: "translate(-50%, -50%)",
                        }}/>
                    </div>
                    <div className="Content__testimonials--testimonial-dots">
                        <h2>,,</h2>
                    </div>
                    <div className="Content__testimonials--testimonial-title">
                        <h4>Nicolás Justiniano</h4>
                    </div>
                    <div className="Content__testimonials--testimonial-text">
                        <p>Recíbelo ha sido un gran partner estratégico para nosotros, destacándose por su flexibilidad al considerar nuevas propuestas, lo que ha permitido mantener una colaboración activa con los servicios Sameday, Nextday y Logística Inversa. Además, gracias a su atención y respuestas rápidas hemos logrado una comunicación fluida y bidireccional.</p>
                    </div>
                    <div className="Content__testimonials--testimonial-logo">
                        <a href="https://enviame.io" target="_blank">
                            <img src={enviameLogo} alt="enviame-logo" width="250" height="75" />
                        </a>
                    </div>
                </div>
                <div className="Content__testimonials--testimonial">
                    <div className="Content__testimonials--testimonial-icon">
                        <img src={goexCEO} alt="goex-ceo" style={{
                                width: "128%",
                                height: "auto",
                                objectFit: "cover",
                                position: "absolute",
                                top: "62%",
                                left: "59%",
                                transform: "translate(-50%, -50%)",
                        }}/>
                    </div>
                    <div className="Content__testimonials--testimonial-dots">
                        <h2>,,</h2>
                    </div>
                    <div className="Content__testimonials--testimonial-title">
                        <h4>Emiliano  Loza</h4>
                    </div>
                    <div className="Content__testimonials--testimonial-text">
                        <p>Recibelo ha sido un gran partner estratégico para la distribución de todos los envíos que preparamos en nuestros darkstores. Entregas en tiempo y forma que nos permiten ser día a día más competitivos en la industria del fulfillment. Un servicio 5 estrellas.</p>
                    </div>
                    <div className="Content__testimonials--testimonial-logo">
                        <a href="https://www.go-ex.io" target="_blank">
                            <img src={goexLogo} alt="goex-logo" style={{maxWidth: '175px'}} width="175" height="62" />
                        </a>
                    </div>
                </div>
                <div className="Content__testimonials--testimonial">
                    <div className="Content__testimonials--testimonial-icon">
                        <img src={cosmeticCLCEO} alt="cosmecit-cl-ceo" style={{objectFit: "cover"}} />
                    </div>
                    <div className="Content__testimonials--testimonial-dots">
                        <h2>,,</h2>
                    </div>
                    <div className="Content__testimonials--testimonial-title">
                        <h4>Marcelo Avendaño</h4>
                    </div>
                    <div className="Content__testimonials--testimonial-text">
                        <p>Recibelo se ha convertido en nuestro partner estratégico, permitiendonos fortalecer nuestra misión de entregar los pedidos en forma y tiempo. El trabajo conjunto nos ha permitido crecer en número de pedidos, ya que nuestros clientes valoran el rápido tiempo de entrega.  Además dispone de un equipo comprometido y flexible lo que nos permite tener una comunicación fluida en la resolución de problemas o cambios logisticos.</p>
                    </div>
                    <div className="Content__testimonials--testimonial-logo">
                        <a href="https://cosmetic.cl" target="_blank">
                            <img src={cosmeticCLLogo} style={{maxWidth: "280px"}} alt="cosmetic-cl-logo" width="280" height="145" />
                        </a>
                    </div>
                </div>
                <div className="Content__testimonials--testimonial">
                    <div className="Content__testimonials--testimonial-icon">
                        <img src={italmodCEO} alt="italmod-ceo"
                            style={{
                                width: "119%",
                                height: "auto",
                                objectFit: "cover",
                                position: "absolute",
                                top: "59%",
                                left: "55%",
                                transform: "translate(-50%, -50%)",
                            }}
                        />
                    </div>
                    <div className="Content__testimonials--testimonial-dots">
                        <h2>,,</h2>
                    </div>
                    <div className="Content__testimonials--testimonial-title">
                        <h4>Rene L. Aguilera</h4>
                    </div>
                    <div className="Content__testimonials--testimonial-text">
                        <p>Recíbelo nos ha ayudado a bajar nuestros tiempos de entrega en la Región Metropolitana a tiempos mínimos. Además nos mantienen informados constantemente de cualquier incidencia de nuestros pedidos con un contacto cercano y personalizado.</p>
                    </div>
                    <div className="Content__testimonials--testimonial-logo">
                        <a href="https://www.italmod.cl" target="_blank">
                            <img src={italmodLogo} alt="italmod-logo" width="250" height="129" />
                        </a>
                    </div>
                </div>
                <div className="Content__testimonials--testimonial">
                    <div className="Content__testimonials--testimonial-icon">
                        <img src={shipitCEO} alt="shipit-ceo"
                            style={{
                                objectFit: "cover"
                            }}
                        />
                    </div>
                    <div className="Content__testimonials--testimonial-dots">
                        <h2>,,</h2>
                    </div>
                    <div className="Content__testimonials--testimonial-title">
                        <h4>Lucas Cardinali</h4>
                    </div>
                    <div className="Content__testimonials--testimonial-text">
                        <p>Consideramos a Recibelo un partner clave para el ecosistema logístico de Chile. Confiamos en ellos para distribuir miles de paquetes al mes destacando su calidad de servicio y compromiso con las entregas.</p>
                    </div>
                    <div className="Content__testimonials--testimonial-logo">
                        <a href="https://www.italmod.cl" target="_blank">
                            <img src={shipitLogo} alt="shipit-logo" width="250" height="75" />
                        </a>
                    </div>
                </div>
                <div className="Content__testimonials--testimonial">
                    <div className="Content__testimonials--testimonial-icon"
                        style={{
                            backgroundColor: '#164665',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <img src={progamingIco} alt="progaming-icon"
                            style={{
                                objectFit: "contain",
                                maxWidth: '100px',
                                marginTop: '11px',
                            }}
                        />
                    </div>
                    <div className="Content__testimonials--testimonial-dots">
                        <h2>,,</h2>
                    </div>
                    <div className="Content__testimonials--testimonial-title">
                        <h4>Jairo Aravena</h4>
                    </div>
                    <div className="Content__testimonials--testimonial-text">
                        <p>Recibelo ha sido un aliado en todos nuestros procesos de crecimiento y expansión para lograr diferenciarnos en servicio en industrias sumamente competitivas, siempre han sido muy preocupados por el nivel de cumplimiento lo que permite cumplir con todas las exigencias que hoy el mercado impone. Ademas tienen un gran equipo, muy profesional y con una atencion que logra resolver cualquier problema en plazos muy bajos. Realmente un gran servicio.</p>
                    </div>
                    <div className="Content__testimonials--testimonial-logo">
                        <a href="https://www.italmod.cl" target="_blank">
                            <img src={progamingLogo} alt="shipit-logo" width="250" height="75" />
                        </a>
                    </div>
                </div>
                <div className="Content__testimonials--testimonial">
                    <div className="Content__testimonials--testimonial-icon"
                        style={{
                            backgroundColor: '#164665',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <img src={dust2Ico} alt="shipit-ceo"
                            style={{
                                objectFit: "cover",
                                maxWidth: '100px',
                                maxHeight: '100px',
                            }}
                        />
                    </div>
                    <div className="Content__testimonials--testimonial-dots">
                        <h2>,,</h2>
                    </div>
                    <div className="Content__testimonials--testimonial-title">
                        <h4>Grace Gonzales</h4>
                    </div>
                    <div className="Content__testimonials--testimonial-text">
                        <p>Tanto la estructura, procesos, sistemas, integraciones y equipo de Recibelo nos han permitido aumentar considerablemente el nivel de satisfacción de nuestros clientes, quienes valoran de gran manera el poder recibir su compra el mismo dia. Sus software de primer nivel nos permite tanto a nosotros como a nuestros clientes estar siempre informados y actualizados con los estados de entrega de los envios. Son un equipo comprometido y responsable logrando un buen servicio incluso en las mas altas temporadas.</p>
                    </div>
                    <div className="Content__testimonials--testimonial-logo">
                        <a href="https://www.italmod.cl" target="_blank">
                            <img src={dust2Logo} alt="shipit-logo" width="250" height="75" />
                        </a>
                    </div>
                </div>
                <div className="Content__testimonials--testimonial">
                    <div className="Content__testimonials--testimonial-icon"
                        style={{
                            backgroundColor: '#d9f0ff',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <img src={ginoLogo} alt="cosmecit-cl-ceo" style={{objectFit: "cover"}} />
                    </div>
                    <div className="Content__testimonials--testimonial-dots">
                        <h2>,,</h2>
                    </div>
                    <div className="Content__testimonials--testimonial-title">
                        <h4>Daniel Iglesias</h4>
                    </div>
                    <div className="Content__testimonials--testimonial-text">
                        <p>Trabajar con Recibelo ha sido una experiencia sumamente positiva. Desde el primer día, se han convertido en un partner estratégico que entiende la importancia de la puntualidad y precisión en los despachos. Con Recibelo, se puede garantizar a los clientes la mejor experiencia de compra, sabiendo que se cuenta con un aliado que comparte altos estándares de calidad y excelencia.</p>
                    </div>
                    <div className="Content__testimonials--testimonial-logo">
                        <a href="https://www.gino.cl" target="_blank">
                            <img src={ginoLogo} style={{maxWidth: "auto", width: 'auto', height: '125px'}} alt="cosmetic-cl-logo" width="280" height="145" />
                        </a>
                    </div>
                </div>
                <div className="Content__testimonials--testimonial">
                    <div className="Content__testimonials--testimonial-icon"
                        style={{
                            backgroundColor: '#d9f0ff',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <img src={westorageIco} alt="cosmecit-cl-ceo" style={{objectFit: "cover"}} />
                    </div>
                    <div className="Content__testimonials--testimonial-dots">
                        <h2>,,</h2>
                    </div>
                    <div className="Content__testimonials--testimonial-title">
                        <h4>Javier Atala</h4>
                    </div>
                    <div className="Content__testimonials--testimonial-text">
                        <p>Sabemos mejor que nadie que tercerizar cualquier aspecto de la operación es complejo y delicado, sobre todo si se trata de un proceso crítico del negocio, como lo es para nosotros la última milla. En ese sentido, como Operador Logístico, es clave contar con un proveedor serio y de confianza como Recíbelo, ya que su labor repercute directamente en nuestros niveles de servicio y la satisfacción de nuestros clientes.</p>
                    </div>
                    <div className="Content__testimonials--testimonial-logo">
                        <a href="https://westorage.cl" target="_blank">
                            <img src={westorageLogo} style={{maxWidth: "220px"}} alt="cosmetic-cl-logo" width="250" height="145" />
                        </a>
                    </div>
                </div>
                <div className="Content__testimonials--testimonial">
                    <div className="Content__testimonials--testimonial-icon"
                        style={{
                            backgroundColor: '#d9f0ff',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <img src={productosdelujoCeo} alt="cosmecit-cl-ceo" style={{objectFit: "cover"}} />
                    </div>
                    <div className="Content__testimonials--testimonial-dots">
                        <h2>,,</h2>
                    </div>
                    <div className="Content__testimonials--testimonial-title">
                        <h4>Kamal Pokhrel</h4>
                    </div>
                    <div className="Content__testimonials--testimonial-text">
                        <p>Recíbelo ha sido un aliado clave para nosotros desde el 2021, destacándose por su puntualidad y fiabilidad en cada entrega de nuestros productos. Siempre han demostrado un alto nivel de profesionalismo, Además, su atención rápida y comunicación fluida han sido claves para garantizar la satisfacción de nuestros clientes. ¡Gracias por su compromiso y excelente servicio!</p>
                    </div>
                    <div className="Content__testimonials--testimonial-logo">
                        <a href="https://productosdelujo.cl" target="_blank">
                            <img src={productosdelujoLogo} style={{maxWidth: "220px", maxHeight: '160px', width: 'fit-content'}} alt="cosmetic-cl-logo" width="250" height="145" />
                        </a>
                    </div>
                </div>
                <div className="Content__testimonials--testimonial">
                    <div className="Content__testimonials--testimonial-icon"
                        style={{
                            backgroundColor: '#d9f0ff',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <img src={nordvickLogo} alt="cosmecit-cl-ceo" style={{objectFit: "cover"}} />
                    </div>
                    <div className="Content__testimonials--testimonial-dots">
                        <h2>,,</h2>
                    </div>
                    <div className="Content__testimonials--testimonial-title">
                        <h4>Maria Jose Morah</h4>
                    </div>
                    <div className="Content__testimonials--testimonial-text">
                        <p>RECIBELO ha sido un aliado invaluable durante más de tres años. Su adaptabilidad y excelente comunicación han sido clave para una colaboración efectiva en servicios same-day, next-day y logística inversa, mejorando nuestra eficiencia operativa. Agradecemos su compromiso y dedicación, esenciales para nuestro éxito.</p>
                    </div>
                    <div className="Content__testimonials--testimonial-logo">
                        <a href="https://www.nordvik.cl" target="_blank">
                            <img src={nordvickLogo} style={{maxWidth: "220px", maxHeight: '160px', width: 'fit-content'}} alt="cosmetic-cl-logo" width="250" height="145" />
                        </a>
                    </div>
                </div>
            </Slider>
            <div className="Content__testimonials--button">
                <Link to={'/contacto'}>
                    <button>Contáctanos</button>
                </Link>
            </div>
        </div>
    </div>
  )
}

export { Testimonials }